var map = {
	"./19th-hole.svg": 673,
	"./5-star-clubhouse.svg": 674,
	"./alert.svg": 675,
	"./arrow.svg": 676,
	"./award.svg": 677,
	"./ballot.svg": 678,
	"./best-dinner.svg": 679,
	"./checkmark.png": 680,
	"./chevron-down.svg": 681,
	"./close-rounded.svg": 682,
	"./close.svg": 683,
	"./expand.svg": 684,
	"./food-at-turn.svg": 685,
	"./golf-cart.svg": 686,
	"./golfweek-flag.svg": 89,
	"./great-staff.svg": 687,
	"./handbook.svg": 688,
	"./logout.svg": 689,
	"./menu.svg": 690,
	"./message.svg": 691,
	"./pencil.svg": 692,
	"./pin.svg": 693,
	"./practice-area.svg": 694,
	"./profile.svg": 695,
	"./range-slider.svg": 696,
	"./star.svg": 697,
	"./swing.svg": 698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 672;